export const PENDING_STATUS = 'pending';
export const REJECTED_STATUS = 'rejected';
export const RESOLVED_STATUS = 'resolved';

export const REDUX_REST_PREFIX = '@@resource';
